import * as React from "react";
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import closeIcon from '../assets/images/cross-close.svg';
import clockIcon from '../assets/images/clock.svg';

import { useDispatch, useSelector } from "react-redux";
import {
    GridRowModes,
    DataGrid,
    GridActionsCellItem,
    GridRowEditStopReasons,
} from '@mui/x-data-grid';
import { Tooltip } from '@mui/material';

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { format } from 'date-fns';

import menuIcon from '../assets/images/menu-icon.svg';
import searchIcon from '../assets/images/search-icon.svg';
import filterIcon from '../assets/images/filter-red-icon.svg';
import crossIcon from '../assets/images/cross-close.svg';
import calLoader from '../assets/images/calendar-loader.svg';

import { useState } from "react";
import { useEffect } from "react";

import { styled } from '@mui/material/styles';
import { HistoryActionLogs } from "../ui/HistoryActionLogs";
import { variables } from "../Variables";
import { titleSafeParse } from "../utils/commonService";
import { setShowWaitingAndEventsModal } from "../features/ShowWaitingAndEventsModal";

const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: 'rgba(18, 18, 18, 0.9)',
    ...theme.applyStyles('light', {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
    }),
}));

const CustomLoadingOverlay = () => {
    return (
        <StyledGridOverlay>
            <img src={calLoader} className="cal-loader" />
        </StyledGridOverlay>
    );
}

export const ContactWaitingListModel = ({ estate }) => {

    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const reduxshowWaitingAndEventsModal = useSelector(state => state.showWaitingAndEventsModal.showWaitingAndEventsModal);
    const reduxClientSetting = useSelector(state => state.setting.setting);
    const dispatch = useDispatch();

    // ── All state that was previously lifted into Calendar.js ─────────────────
    const [contactWaitingListData, setContactWaitingListData] = useState([]);
    const [pageDataGrid, setPageDataGrid] = useState(0);
    const [pageSizeDataGrid, setPageSizeDataGrid] = useState(25);
    const [totalRecordDataGrid, setTotalRecordDataGrid] = useState(0);
    const [filterDataGrid, setFilterDataGrid] = useState("");
    const [statusDataGrid, setStatusDataGrid] = useState(null);
    const [filterSearchEnterkey, setFilterSearchEnterkey] = useState(false);
    const [isLoadingDataGrid, setIsLoadingDataGrid] = useState(true);
    const [tabBtnActiveWaitingList, setTabBtnActiveWaitingList] = useState(1);
    const [waitingListGridAllDataFromApi, setWaitingListGridAllDataFromApi] = useState(null);

    // ── Local state ────────────────────────────────────────────────────────────
    const [enqueueIsChecked, setEnqueueIsChecked] = useState(false);
    const [gridTranslationsLocaleText, setGridTranslationsLocaleText] = useState(null);
    //const [contactTitlesList, setContactTitlesList] = useState([]);

    const getContactWaitingList = async(estate) => {

        try {
            setIsLoadingDataGrid(true);

            let confirmedIds = estate.purposeId == 1 ? reduxClientSetting.visitToSaleAfter : reduxClientSetting.visitToRentAfter;
            let tobeConfirmedIds = estate.purposeId == 1 ? reduxClientSetting.visitToSaleBefore : reduxClientSetting.visitToRentBefore;


            let url;

            if (tabBtnActiveWaitingList == 1) {
                url = `${variables.API_URL}Calendar/GetWaitingListRecords?estateId=${estate.id}&calendarActionIdToBeConfirm=${tobeConfirmedIds}&calendarActionIdConfirmed=${confirmedIds}&search=${filterDataGrid !== "" ? filterDataGrid : null}&status=${statusDataGrid}&pageNumber=${pageDataGrid + 1}&pageSize=${pageSizeDataGrid}`;
            } else if (tabBtnActiveWaitingList == 2 || tabBtnActiveWaitingList == 3) {
                url = `${variables.API_URL}Calendar/GetToBeConfirmOrConfirmedRecords?estateId=${estate.id}&calendarActionIdToBeConfirm=${tobeConfirmedIds}&calendarActionIdConfirmed=${confirmedIds}&isToBeConfirm=${tabBtnActiveWaitingList == 2 ? true : false}&search=${filterDataGrid !== "" ? filterDataGrid : null}&pageNumber=${pageDataGrid + 1}&pageSize=${pageSizeDataGrid}`;
            } else if (tabBtnActiveWaitingList == 4) {
                url = `${variables.API_URL}Calendar/GetBookingSiteAcessLogs?estateId=${estate.id}&calendarActionIdToBeConfirm=${tobeConfirmedIds}&calendarActionIdConfirmed=${confirmedIds}&search=${filterDataGrid !== "" ? filterDataGrid : null}&pageNumber=${pageDataGrid + 1}&pageSize=${pageSizeDataGrid}`;
            }

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            const response = await axios.get(url, config);
            if (response.data) {

                if (response.data.status == ("No record found")) {
                    setContactWaitingListData([]);
                    setIsLoadingDataGrid(false);
                    return;
                }

                let contactTitlesListJsonParse = reduxClientSetting.mappedContactTitles != "" ? JSON.parse(reduxClientSetting.mappedContactTitles) : [];

                const formatedData = response.data.records.map((item, index) => {
                    const contactTitleId = titleSafeParse(item.title); // JSON.parse(item.title); => we handle empty {}, therefore, we use this function
                    let contactTitle;
                    if (contactTitlesListJsonParse != null && contactTitlesListJsonParse.length > 0) {
                        const filterContactTitle = contactTitlesListJsonParse.filter(contactTitleItem => contactTitleItem.value == (contactTitleId.Id || contactTitleId));
                        contactTitle = filterContactTitle.length > 0 ? reduxSelectedLanguage == "en-GB" ? filterContactTitle[0].labelEn : reduxSelectedLanguage == "fr-BE" ? filterContactTitle[0].labelFr : filterContactTitle[0].labelNl : "";
                    } else {
                        contactTitle = "";
                    }

                    return {
                        ...item,
                        id: index + 1,
                        dateDescription: format(new Date(item.dateDescription || item.eventStartDate || item.accessDateTime), 'dd/MM/yyyy - HH:mm'),
                        title: contactTitle // //parsedTitle.label
                    };
                });

                setContactWaitingListData(formatedData);
                setTotalRecordDataGrid(response.data.filteredTotalRecordsInDB);
                setPageSizeDataGrid(response.data.pageSize);
                setWaitingListGridAllDataFromApi(response.data);

                if (response.data.accessLogsTotalCount != 0 || response.data.confirmedEventsTotalCount != 0 || response.data.toBeConfirmedEventsTotalCount != 0 || response.data.waitingListTotalCount != 0) {
                    //setWaitListBtnEnabled(true);
                } else {
                    //setWaitListBtnEnabled(false);
                }

                // 1-second loading delay => remove jerk
                setTimeout(() => {
                    setIsLoadingDataGrid(false);
                }, 1000);

                /* setIsLoadingDataGrid(false);*/
            }

        } catch (error) {
            console.error(error);
            setIsLoadingDataGrid(false);
        }

    }

    // open waiting list and events histroy modal
    useEffect(() => {
        if (estate && reduxshowWaitingAndEventsModal) {
            getContactWaitingList(estate); // get waiting list data
        }
    }, [reduxshowWaitingAndEventsModal, filterSearchEnterkey, pageSizeDataGrid, pageDataGrid, statusDataGrid, tabBtnActiveWaitingList]);

    let columns = [
        {
            field: tabBtnActiveWaitingList == 1 ? 'dateDescription' : tabBtnActiveWaitingList == 4 ? 'accessDateTime' : 'eventStartDate',
            headerName: tabBtnActiveWaitingList == 1 ? reduxLanguageTranslations != null ? reduxLanguageTranslations["registrationDate"] : 'Registration Date' : tabBtnActiveWaitingList == 4 ? reduxLanguageTranslations != null ? reduxLanguageTranslations["accessDateTime"] : 'Access Date Time' : reduxLanguageTranslations != null ? reduxLanguageTranslations["eventDate"] : 'Event Date',
            flex: 1,
        },
        {
            field: 'eventStartTime',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["eventStartTime"] : 'Event Start Time',
            flex: 1,
        },
        {
            field: 'ipAddress',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["ipAddress"] : 'IP Address',
            flex: 1,
        },
        {
            field: 'whiseContactId',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["contactId"] : 'Contact Id',
            flex: 1,
        },
        {
            field: 'title',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["titleLabel"] : 'Title',
            //flex: 1,
            width: 60,
        },
        {
            field: 'firstName',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["firstNameLabel"] : 'First Name',
            flex: 1,
        },
        {
            field: 'name',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["lastName"] : 'Name',
            flex: 1,
        },
        {
            field: 'email',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["email"] : 'Email',
            flex: 1,
            minWidth: 215,
        },
        {
            field: 'mobile',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["mobile"] : 'Mobile',
            flex: 1,
        },
        {
            field: 'status',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["status"] : 'Status',
            flex: 1,
            renderCell: (params) => {
                const isEmailSent = params.value; // condition
                const bgColor = isEmailSent === "Email Sent" ? "#27A376" : isEmailSent === "Enqueue" ? "#e52929" : "#ff6c00"; // green / gray 
                const textColor = "#ffffff";

                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <Tooltip
                            title={isEmailSent}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: "#fff",
                                        color: "#181818",
                                        fontSize: "11px",
                                        boxShadow: 1,
                                        border: "1px solid #000",
                                    },
                                },
                            }}
                            placement="bottom-end"
                            slotProps={{
                                popper: {
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, -18],
                                            },
                                        },
                                    ],
                                },
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: bgColor,
                                    color: textColor,
                                    width: "105px",
                                    height: "40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "11px",
                                    padding: "0 6px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    maxWidth: "105px",
                                    minWidth: "105px",
                                }}
                            >
                                <span
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {isEmailSent}
                                </span>
                            </div>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'actions',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["actions"] : 'Action',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => (
                <img
                    src={menuIcon}  // your image path here
                    alt="View"
                    style={{ width: 15, height: 15, cursor: 'pointer' }}
                    onClick={() => console.log('Clicked row:', params.row)}
                    title={reduxLanguageTranslations != null ? reduxLanguageTranslations["soonToBeRelease"] : "Soon to be release"}
                />
            ),
        },
    ]

    // console.log(columns);

    if (tabBtnActiveWaitingList == 1) {
        columns = columns.filter(item => item.field != "ipAddress" && item.field != "eventStartTime");
    } else if (tabBtnActiveWaitingList == 4) {
        columns = columns.filter(item => item.field != "actions" && item.field != "status" && item.field != "eventStartTime");
    } else {
        columns = columns.filter(item => item.field != "ipAddress" && item.field != "actions" && item.field != "status");
    }

    const handleCloseContactWaitingListModal = () => {
        dispatch(setShowWaitingAndEventsModal(false));
        setPageDataGrid(0);
        setPageSizeDataGrid(25);
        setTotalRecordDataGrid(0);
        setStatusDataGrid(null);
        setFilterDataGrid("");
        setFilterSearchEnterkey(false);
        setTabBtnActiveWaitingList("1");
    }

    const onChangeFilterDataGridRecord = (event) => {
        const value = event.target.value;
        setFilterDataGrid(value);
        //setPageDataGrid(0); // reset to first page

        // Reset search trigger only when input is cleared
        if (value.trim().length === 0) {
            //setFilterSearchEnterkey(false);
            setFilterSearchEnterkey(!filterSearchEnterkey);
            setPageDataGrid(0);
        }
    }

    const handleToggleEnqueueChecked = () => {
        setEnqueueIsChecked((prev) => {
            const newValue = !prev;
            setStatusDataGrid(newValue ? "Email Sent" : "Enqueue"); //null
            return newValue;
        });
    };

    const clearSearchFilerBox = () => {
        setFilterDataGrid("");
        /*setFilterSearchEnterkey(false);*/
        setFilterSearchEnterkey(!filterSearchEnterkey);
    }

    const onEnterKeyPressInSearchBox = (e) => {
        //console.log(e.key);
        if (e.key === "Enter") {
            /*setFilterSearchEnterkey(true);*/
            setPageDataGrid(0);
            setFilterSearchEnterkey(!filterSearchEnterkey);
        }
    }

    const resetAllDataGrid = () => {
        setFilterDataGrid("");
        setStatusDataGrid(null);
    }

    const resetAllField = () => {
        setFilterDataGrid("");
        setStatusDataGrid("Enqueue");
        setPageDataGrid(0);
        setPageSizeDataGrid(25);
        setTotalRecordDataGrid(0);
    }

    const onClickFilterBtn = () => {
        setFilterSearchEnterkey(!filterSearchEnterkey);
    }

    const onClickTabBtnWaitingList = (e) => {
        const value = e;
        resetAllField();
        setTabBtnActiveWaitingList(value);
    }

    useEffect(() => {
        setIsLoadingDataGrid(true);
    }, []);

    useEffect(() => {
        if (reduxLanguageTranslations) {
            let gridTranslationObj = {
                // Column menu text
                columnMenuUnsort: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuUnsort"] : "columnMenuUnsort",
                columnMenuSortAsc: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuSortAsc"] : "columnMenuSortAsc",
                columnMenuSortDesc: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuSortDesc"] : "columnMenuSortDesc",
                columnMenuFilter: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuFilter"] : "columnMenuFilter",
                columnMenuHideColumn: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuHideColumn"] : "columnMenuHideColumn",
                columnMenuShowColumns: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuShowColumns"] : "columnMenuShowColumns",
                columnMenuLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuLabel"] : "Menu",
                columnHeaderSortIconLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnHeaderSortIconLabel"] : "Sort",

                // Filter panel text
                filterPanelDeleteIconLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelDeleteIconLabel"] : "Delete",
                filterPanelOperator: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelOperator"] : "Operator",
                filterPanelColumns: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelColumns"] : "Columns",
                filterPanelInputLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelInputLabel"] : "Value",
                filterPanelInputPlaceholder: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelInputPlaceholder"] : "Filter value",

                // Filter operators text
                filterOperatorContains: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorContains"] : "contains",
                filterOperatorDoesNotContain: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorDoesNotContain"] : "does not contain",
                filterOperatorEquals: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorEquals"] : "equals",
                filterOperatorDoesNotEqual: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorDoesNotEqual"] : "does not equal",
                filterOperatorStartsWith: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorStartsWith"] : "starts with",
                filterOperatorEndsWith: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorEndsWith"] : "ends with",
                filterOperatorIsEmpty: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorIsEmpty"] : "is empty",
                filterOperatorIsNotEmpty: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorIsNotEmpty"] : "is not empty",
                filterOperatorIsAnyOf: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorIsAnyOf"] : "is any of",

                // noRowsLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["noAgentFound"] : 'No agent found',

                // Used table pagination translation keys
                MuiTablePagination: {
                    getItemAriaLabel: (type) => {
                        if (type === 'first') {
                            return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToFirstPageBtnLabel"] : "Go to first page";
                        }
                        if (type === 'last') {
                            return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToLastPageBtnLabel"] : "Go to last page";
                        }
                        if (type === 'next') {
                            return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToNextPageBtnLabel"] : "Go to next page";
                        }
                        return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToPreviousPageBtnLabel"] : "Go to previous page";
                    },
                    labelRowsPerPage: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridLabelRowsPerPage"] : "Rows per page:",
                }
            }
            setGridTranslationsLocaleText(gridTranslationObj);
        }
    }, [reduxLanguageTranslations])

    return (
        <>
            <Modal show={reduxshowWaitingAndEventsModal} onHide={handleCloseContactWaitingListModal} className="contactWaitingListModal modalStyle p-0">
                <Modal.Body className="p-0">
                    <div className="modal-container">
                        <div className="d-flex justify-content-end mb-3">
                            <img src={closeIcon} onClick={handleCloseContactWaitingListModal} className="cursor-pointer" />
                        </div>
                        <div className="waiting-list-container px-4">
                            <div className="row mb-3">
                                <div className="col-md-12 col-lg-7">
                                    <div class="tab-waiting-list-container btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                        <div class="btn-group" role="group">
                                            <button type="button" className={`btn btn-tab-waiting-list ${tabBtnActiveWaitingList == 1 ? "tab-active-btn-waiting-list" : ""}`} onClick={() => onClickTabBtnWaitingList(1)}>{reduxLanguageTranslations ? (reduxLanguageTranslations["waitingListHeading"]).toUpperCase() : "Waiting list"} ({waitingListGridAllDataFromApi != null ? waitingListGridAllDataFromApi.waitingListTotalCount : ""}) </button>
                                            <button type="button" className={`btn btn-tab-waiting-list ${tabBtnActiveWaitingList == 2 ? "tab-active-btn-waiting-list" : ""}`} onClick={() => onClickTabBtnWaitingList(2)}>{reduxLanguageTranslations ? reduxLanguageTranslations["requestedStatus"] : "REQUESTED"} ({waitingListGridAllDataFromApi != null ? waitingListGridAllDataFromApi.toBeConfirmedEventsTotalCount : ""})</button>
                                            <button type="button" className={`btn btn-tab-waiting-list ${tabBtnActiveWaitingList == 3 ? "tab-active-btn-waiting-list" : ""}`} onClick={() => onClickTabBtnWaitingList(3)}>{reduxLanguageTranslations ? reduxLanguageTranslations["acceptedStatus"] : "ACCEPTED"} ({waitingListGridAllDataFromApi != null ? waitingListGridAllDataFromApi.confirmedEventsTotalCount : ""})</button>
                                            <button type="button" className={`btn btn-tab-waiting-list ${tabBtnActiveWaitingList == 4 ? "tab-active-btn-waiting-list" : ""}`} onClick={() => onClickTabBtnWaitingList(4)}>{reduxLanguageTranslations ? reduxLanguageTranslations["landedStatus"] : "LANDED"} ({waitingListGridAllDataFromApi != null ? waitingListGridAllDataFromApi.accessLogsTotalCount : ""})</button>
                                            {/*<button type="button" className={`btn btn-tab-waiting-list ${tabBtnActiveWaitingList == 5 ? "tab-active-btn-waiting-list" : ""}`} onClick={() => onClickTabBtnWaitingList(5)}>History (000)</button>*/}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-5">
                                    <div className="d-flex">
                                        <div className="w-100">
                                            <TextField
                                                variant="outlined"
                                                placeholder={reduxLanguageTranslations != null ? reduxLanguageTranslations["searchByWaitingListFields"] : "Search by email, first name, name, mobile"} //"Search"
                                                value={filterDataGrid}
                                                onChange={(e) => onChangeFilterDataGridRecord(e)}
                                                onKeyDown={(e) => onEnterKeyPressInSearchBox(e)}
                                                size="small"
                                                sx={{
                                                    width: "100%",
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: 2,
                                                        "& fieldset": {
                                                            borderColor: "#1118270D", // Default border
                                                        },
                                                        "&:hover fieldset": {
                                                            borderColor: "#1118270D", // Hover border
                                                        },
                                                        "&.Mui-focused fieldset": {
                                                            borderColor: "#1118270D", // Focus border
                                                        },
                                                    },
                                                }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start" sx={{ mr: 2 }}>
                                                            <img src={searchIcon} alt="search" width="15" height="15" />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: (
                                                        filterDataGrid && (
                                                            <InputAdornment position="end">
                                                                <img
                                                                    src={crossIcon}
                                                                    alt="clear"
                                                                    width="14"
                                                                    height="14"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={clearSearchFilerBox}
                                                                />
                                                            </InputAdornment>
                                                        )
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div className="waitinglist-filter-icon d-flex align-items-center ms-2 px-2 border rounded" onClick={() => onClickFilterBtn()} style={{ cursor: "pointer" }}>
                                            <img className="me-2" src={filterIcon} alt="search" width="15" height="15" />
                                            <span>{reduxLanguageTranslations != null ? reduxLanguageTranslations["calendarPageFilterBtn"] : "Filter"}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="waiting-list-hr my-3" />
                            <div className={`d-flex justify-content-between align-items-center mb-3`}>
                                <h5 className="mb-0">
                                    <span className="me-1">
                                        {
                                            tabBtnActiveWaitingList == 1 ?
                                                reduxLanguageTranslations ? reduxLanguageTranslations["waitingListHeading"].toUpperCase() : "Waiting list"
                                                :
                                                tabBtnActiveWaitingList == 2 ?
                                                    reduxLanguageTranslations ? reduxLanguageTranslations["requestedStatus"] : "REQUESTED"
                                                    :
                                                    tabBtnActiveWaitingList == 3 ?
                                                        reduxLanguageTranslations ? reduxLanguageTranslations["acceptedStatus"] : "ACCEPTED"
                                                        :
                                                        reduxLanguageTranslations ? reduxLanguageTranslations["landedStatus"] : "LANDED"
                                        }
                                    </span>
                                    <span>
                                        ({contactWaitingListData.length > 0 ? totalRecordDataGrid : 0})
                                    </span>
                                </h5>
                                <div className={`${tabBtnActiveWaitingList != 1 ? "d-none" : "d-flex"}`}>
                                    <button className="me-2 rounded fw-bold px-3" onClick={() => resetAllDataGrid()}>{reduxLanguageTranslations ? reduxLanguageTranslations["showAll"] : "Show all"}</button>
                                    <div className="enqueue-toggle-btn form-check form-switch border rounded">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            id="flexSwitchCheckChecked"
                                            checked={statusDataGrid == null || enqueueIsChecked == false || statusDataGrid == "Enqueue" ? false : enqueueIsChecked}
                                            onChange={handleToggleEnqueueChecked}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="flexSwitchCheckChecked"
                                        >
                                            {enqueueIsChecked == false || statusDataGrid == null || statusDataGrid == "Enqueue" ? reduxLanguageTranslations ? reduxLanguageTranslations["enqueue"] : "Enqueue" : reduxLanguageTranslations ? reduxLanguageTranslations["sent"] : "Sent"}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {
                                tabBtnActiveWaitingList != 5 ?
                                    <div className="contactWaitingListGridContainer">
                                        {
                                            contactWaitingListData.length > 0 ?
                                                <DataGrid
                                                    rows={contactWaitingListData}
                                                    columns={columns}
                                                    rowCount={totalRecordDataGrid}
                                                    paginationMode="server"
                                                    paginationModel={{ page: pageDataGrid, pageSize: pageSizeDataGrid }}
                                                    onPaginationModelChange={(newModel) => {
                                                        //console.log("Pagination changed:", newModel);
                                                        setPageDataGrid(newModel.page);
                                                        setPageSizeDataGrid(newModel.pageSize);
                                                    }}
                                                    pageSizeOptions={[25, 50, 100]}
                                                    disableRowSelectionOnClick
                                                    getRowClassName={(params) =>
                                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row-waiting-grid' : 'odd-row-waiting-grid'
                                                    }
                                                    loading={isLoadingDataGrid}
                                                    disableColumnMenu   // hide column menu (3-dot icon)
                                                    localeText={gridTranslationsLocaleText} // multi-legul language
                                                    slots={{
                                                        loadingOverlay: CustomLoadingOverlay,
                                                    }}
                                                />
                                                :
                                                <p className="text-center fw-bold d-flex justify-content-center align-items-center" style={{ minHeight: "35vh" }}>
                                                    <span className="me-1">
                                                        {tabBtnActiveWaitingList == 1 ? statusDataGrid != null ? statusDataGrid : ""
                                                            : tabBtnActiveWaitingList == 2 ?
                                                                reduxLanguageTranslations ? reduxLanguageTranslations["requestedStatus"] : "REQUESTED"
                                                                : tabBtnActiveWaitingList == 3 ?
                                                                    reduxLanguageTranslations ? reduxLanguageTranslations["acceptedStatus"] : "ACCEPTED"
                                                                    :
                                                                    reduxLanguageTranslations ? reduxLanguageTranslations["landedStatus"] : "LANDED"
                                                        }
                                                    </span>
                                                    {reduxLanguageTranslations ? reduxLanguageTranslations["recordNotFound"] : "Record not found!"}
                                                </p>
                                        }
                                    </div>

                                    :
                                    <HistoryActionLogs />
                            }

                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
